// extracted by mini-css-extract-plugin
export var disabled = "_r-a";
export var hierarchyLinkGray = "_r-4";
export var hierarchyLinkUnderline = "_r-3";
export var hierarchyPrimary = "_r-0";
export var hierarchySecondary = "_r-1";
export var hierarchyTertiary = "_r-2";
export var pressed = "_r-6";
export var themeAction = "_r-5";
export var themeDestructive = "_r-8";
export var themeNormal = "_r-7";
export var themeSuccess = "_r-9";